<template>
    <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 442.07 210.82">
        <defs>
            <clipPath id="clippath">
                <rect
                    x="305.11"
                    y="79.45"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-1">
                <rect
                    x="13.49"
                    y="87.95"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
        </defs>
        <g id="Layer_2-2">
            <g
                id="Group_586"
                opacity=".56">
                <g id="Group_585">
                    <g clip-path="url(#clippath)">
                        <g id="Group_584">
                            <path
                                id="Path_1402"
                                d="m418.67,163.11l-59.11,33.17c-2.7,1.51-6.1.55-7.62-2.14l-46.11-82.18c-1.51-2.7-.55-6.1,2.14-7.62l44.09-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.15,7.57,0,0-.01,0-.02,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_1403"
                                d="m403.75,185.74l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58h-.01"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1404"
                                d="m403.75,185.74l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58,0,0-.01,0-.02,0Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_1405"
                                d="m408.3,108.24l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1406"
                                d="m408.3,108.24l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.62.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <rect
                id="Rectangle_329"
                x="285.95"
                y="56.79"
                width="156.07"
                height="21.3"
                fill="#f47941"
                stroke-width="0" />
            <path
                id="Path_2338"
                d="m338.81,62.03c-2.09,0-3.79,1.7-3.79,3.79s2.86,5.06,3.88,6.72c1.01-1.67,3.7-4.59,3.7-6.72s-1.7-3.78-3.79-3.79m0,5.42c-.96,0-1.73-.78-1.73-1.74s.78-1.73,1.74-1.73,1.73.78,1.73,1.74h0c0,.96-.78,1.73-1.74,1.73"
                fill="#fff"
                stroke-width="0" />
            <text
                transform="translate(346.77 71.24)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    You are here
                </tspan>
            </text>
            <path
                id="Path_2278"
                d="m138.16,21.42c9.5,0,17.19,7.7,17.2,17.2v152.93c0,9.5-7.7,17.19-17.2,17.2H18.88c-9.5,0-17.19-7.7-17.2-17.2V38.62c0-9.5,7.7-17.19,17.2-17.2h119.28Zm0-1.65H18.88C8.47,19.77.03,28.21.03,38.62v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V38.62c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2279"
                d="m155.6,56.8v-15.4c.56-13.68-8.91-20.46-21.35-21.54H21.35C9.51,19.91-.05,29.55,0,41.4v15.4s155.6,0,155.6,0Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2250"
                d="m423.22,21.83c9.5,0,17.19,7.7,17.2,17.2v152.93c-.01,9.49-7.7,17.19-17.2,17.2h-119.27c-9.49,0-17.19-7.71-17.2-17.2V39.03c0-9.5,7.7-17.19,17.2-17.2h119.27Zm0-1.65h-119.27c-10.41,0-18.85,8.44-18.85,18.85v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V39.03c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2251"
                d="m441.59,57.61v-15.34c.09-13.33-9.52-22.76-21.44-21.46h-113.38c-5.31-.08-10.48,1.7-14.63,5.02-4.56,3.93-6.82,9.95-6.82,16.44v15.34h156.27Z"
                fill="#5c73b8"
                stroke-width="0" />
            <rect
                id="Rectangle_310"
                x="345.23"
                y=".88"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
            <path
                id="Path_1563"
                d="m75.81,21.17c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                fill="#5c73b8"
                stroke-width="0" />
            <polygon
                points="83.26 26.64 80.26 19.07 88.32 10.92 83.26 26.64"
                fill="#95b1e8"
                stroke-width="0" />
            <polygon
                points="87.36 9.98 79.32 18.15 71.71 15.24 87.36 9.98"
                fill="#95b1e8"
                stroke-width="0" />
            <text
                transform="translate(322.12 48.8)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Linked Program
                </tspan>
            </text>
            <text
                transform="translate(26.79 48.8)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Publishing Program
                </tspan>
            </text>
            <g
                id="Group_579"
                opacity=".56">
                <g id="Group_578">
                    <g clip-path="url(#clippath-1)">
                        <g id="Group_577">
                            <path
                                id="Path_1361"
                                d="m127.05,171.61l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14L14.21,120.47c-1.51-2.7-.55-6.1,2.14-7.62l44.09-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.68.54,6.07-2.15,7.57,0,0-.01,0-.02,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_1362"
                                d="m112.13,194.24l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.45c0,3.08-2.49,5.57-5.56,5.58h-.01"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1363"
                                d="m112.13,194.24l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c0-3.09,2.48-5.6,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.45c0,3.08-2.48,5.57-5.56,5.58,0,0-.01,0-.02,0Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_1364"
                                d="m116.68,116.74l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_1365"
                                d="m116.68,116.74l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.23-.36.38-.62.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_1443"
                d="m71.8,153.76c-2.59.2-4.85-1.74-5.04-4.33-.2-2.59,1.74-4.85,4.33-5.04,2.59-.2,4.85,1.74,5.04,4.33,0,.12.01.24.01.36.09,2.49-1.85,4.59-4.34,4.69"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1444"
                d="m84.23,154.79c-.19,0-.35-.16-.35-.35v-5.27h-5.27c-.19,0-.35-.16-.35-.35,0-.19.16-.35.35-.35h5.62c.19,0,.35.16.35.35v5.62c0,.19-.16.35-.35.35"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1445"
                d="m84.23,166.34c-2.7,0-4.88-2.19-4.88-4.89s2.19-4.89,4.89-4.89c2.7,0,4.88,2.19,4.88,4.89,0,2.7-2.19,4.88-4.89,4.89m0-9.07c-2.31,0-4.19,1.87-4.19,4.19s1.87,4.19,4.19,4.19,4.19-1.87,4.19-4.19h0c0-2.31-1.88-4.18-4.19-4.19"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1446"
                d="m71.81,153.91c-2.7,0-4.89-2.19-4.89-4.88s2.19-4.89,4.88-4.89c2.7,0,4.89,2.19,4.89,4.89h0c0,2.7-2.19,4.88-4.89,4.89m0-9.07c-2.31,0-4.19,1.87-4.19,4.19s1.87,4.19,4.19,4.19,4.19-1.87,4.19-4.19h0c0-2.31-1.88-4.18-4.19-4.19"
                fill="#95b1e8"
                stroke-width="0" />
            <text
                transform="translate(46.81 134.23)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Parent Project
                </tspan>
            </text>
            <text
                transform="translate(341.93 134.23)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Child Project
                </tspan>
            </text>
            <path
                id="Path_1447"
                d="m374.77,151.44c-.19,0-.35-.16-.35-.35h0v-5.27h-5.27c-.19,0-.35-.16-.35-.35s.16-.35.35-.35h5.62c.19,0,.35.16.35.35h0v5.62c0,.19-.16.35-.35.35h0"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1448"
                d="m362.34,150.57c-2.7,0-4.89-2.19-4.89-4.88s2.19-4.89,4.88-4.89c2.7,0,4.89,2.19,4.89,4.88h0c0,2.7-2.19,4.88-4.88,4.89m0-9.07c-2.31,0-4.19,1.87-4.19,4.19,0,2.31,1.87,4.19,4.19,4.19,2.31,0,4.19-1.87,4.19-4.19,0-2.31-1.88-4.18-4.19-4.19"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1449"
                d="m374.88,162.41c-2.59.2-4.85-1.74-5.04-4.33-.2-2.59,1.74-4.85,4.33-5.04,2.59-.2,4.85,1.74,5.04,4.33,0,.12.01.24.01.36.09,2.49-1.85,4.59-4.34,4.69"
                fill="#ced5ea"
                stroke-width="0" />
            <path
                id="Path_1450"
                d="m374.52,162.79c-2.7,0-4.89-2.19-4.89-4.88s2.19-4.89,4.88-4.89c2.7,0,4.89,2.19,4.89,4.88h0c0,2.7-2.19,4.88-4.88,4.89m0-9.07c-2.31,0-4.19,1.87-4.19,4.19,0,2.31,1.87,4.19,4.19,4.19,2.31,0,4.19-1.87,4.19-4.19,0-2.31-1.88-4.18-4.19-4.19"
                fill="#95b1e8"
                stroke-width="0" />
            <rect
                x="312.07"
                y="89.65"
                width="105.47"
                height="30.01"
                fill="none"
                stroke-width="0" />
            <rect
                id="Rectangle_303"
                x="312.28"
                y="89.86"
                width="105.06"
                height="29.6"
                rx="7.17"
                ry="7.17"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke-width="0" />
            <rect
                id="Rectangle_303-2"
                x="312.28"
                y="89.86"
                width="105.06"
                height="29.6"
                rx="7.17"
                ry="7.17"
                fill="none"
                isolation="isolate"
                stroke="#44b649"
                stroke-miterlimit="10" />
            <path
                id="Path_1461"
                d="m331.59,99.28c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.42.17-.58,0s-.17-.42,0-.58c0,0,0,0,0,0,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1462"
                d="m323.82,100.44c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0,0,0,0,0,0,0-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1466"
                d="m329.27,101.61c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.29,3.5-1.29,4.86,0,.16.16.16.42,0,.58-.08.07-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1469"
                d="m328.43,111.56h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1470"
                d="m326.94,111.42c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1474"
                d="m326.63,106.64c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.11-.15-.08-.35.07-.46s.35-.08.46.07c0,0,0,.01.01.02l1.07,1.56c.1.15.07.35-.08.46,0,0,0,0,0,0-.05.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1468"
                d="m328.73,107.7s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.21-.42.06-.17.24-.26.41-.2,0,0,0,0,0,0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1475"
                d="m324.76,104.15c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47.13-.13.34-.13.47,0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1463"
                d="m328.98,104.15c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0,.13.13.13.34,0,.47h0l-1.05,1.06c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1464"
                d="m326.9,110.38c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76c2.08,0,3.76,1.68,3.76,3.76,0,2.08-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1c1.71,0,3.1-1.39,3.1-3.1s-1.39-3.1-3.1-3.1h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1471"
                d="m326.9,107.36c-.41,0-.74-.33-.74-.74s.33-.74.74-.74c.41,0,.74.33.74.74h0c0,.41-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08,0,0,0,0,0,0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1465"
                d="m326.9,110.38c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76c2.08,0,3.76,1.68,3.76,3.76,0,2.08-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1c1.71,0,3.1-1.39,3.1-3.1s-1.39-3.1-3.1-3.1h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1472"
                d="m326.9,104.58c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1473"
                d="m326.9,109.72c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1467"
                d="m329.69,106.94h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1476"
                d="m324.54,106.94h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(339.36 107.81)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Admin Page
                </tspan>
            </text>
            <path
                id="Path_1366"
                d="m222.86,108.34c-.16,0-.3-.11-.34-.26l-4.18-15.74c-.03-.18.07-.36.25-.43l8.23-2.18,4.54,3.24,3.17,11.93c.02.09,0,.18-.04.26-.05.08-.12.14-.21.16l-11.32,3-.09.02Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1367"
                d="m226.7,90.41l4.12,2.94,3.04,11.45-10.8,2.87-4.04-15.23,7.68-2.04Zm.22-1.33h-.03l-8.45,2.24c-.52.14-.82.67-.69,1.18l4.17,15.74c.11.42.5.72.93.72.08,0,.17-.01.25-.03l11.32-3c.51-.13.82-.66.69-1.18l-3.21-12.1s-.02-.05-.04-.07l-4.89-3.49s-.04-.02-.07-.02"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1368"
                d="m231.12,108.47l-11.36-2.88c-.19-.05-.3-.24-.25-.42l4-15.79c.04-.16.18-.27.34-.27l8.34,2.1,2.39,5.03-3.03,11.97c-.04.15-.18.26-.33.26-.03,0-.06,0-.09-.01"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1369"
                d="m224.03,89.8l7.7,1.95,2.18,4.57-2.9,11.49-10.83-2.74,3.86-15.27Zm-.2-1.3c-.44,0-.83.3-.94.73l-4,15.79c-.13.52.18,1.04.7,1.17,0,0,0,0,0,0l11.36,2.88c.08.02.16.03.24.03.44,0,.82-.3.93-.72l3.07-12.14s0-.05,0-.08l-2.58-5.42s-.05-.05-.08-.06l-8.47-2.14c-.08-.02-.16-.03-.24-.03"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1370"
                d="m232.65,95.05c-.17-.05-.31-.17-.39-.33-.1-.21-.13-.45-.07-.67l.46-1.82,1.52,3.2-1.53-.38Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1371"
                d="m232.84,94.05l.22.47-.23-.06c-.05-.08-.06-.17-.03-.26l.04-.15Zm-.33-3.4h0s-.09.04-.1.09l-.8,3.16c-.23.73.17,1.51.9,1.75l2.56.65h.02s.07-.02.1-.04c.03-.03.04-.08.01-.12l-2.58-5.42s-.06-.06-.11-.06"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1372"
                d="m228.88,103.54c0,4.53-3.67,8.2-8.2,8.2s-8.2-3.67-8.2-8.2,3.67-8.2,8.2-8.2h0c4.53,0,8.2,3.67,8.2,8.2"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1373"
                d="m218.68,98.96c-.19.09-.38.21-.55.34-.14.11-.35.08-.46-.06-.11-.14-.09-.34.04-.45,0,0,0,0,.01-.01.21-.16.43-.3.67-.42.17-.08.36-.01.44.16.08.17.01.36-.16.44"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1374"
                d="m218.53,98.33s-.1.01-.14.03c-.24.11-.46.25-.67.42-.14.11-.17.31-.07.45,0,0,0,0,0,.01.11.14.32.17.46.06.17-.13.36-.25.55-.34.16-.08.23-.28.15-.44-.06-.11-.17-.19-.3-.19"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1375"
                d="m222.41,99.83c-.6-.77-1.54-1.21-2.53-1.18-.18,0-.34-.14-.35-.32,0-.18.14-.34.32-.34,1.19-.04,2.34.49,3.07,1.43.11.14.09.34-.04.45,0,0,0,0-.01.01-.15.11-.35.08-.46-.06"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1376"
                d="m220,97.99h-.14c-.18,0-.33.16-.32.34s.16.33.34.32h.13c.94,0,1.83.44,2.41,1.18.06.08.16.12.26.12.07,0,.14-.03.2-.07.14-.11.17-.31.07-.45,0,0,0-.01-.01-.01-.7-.9-1.79-1.43-2.93-1.43"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1377"
                d="m228.7,112.88c.74-.57.88-1.64.31-2.38,0,0,0-.01-.01-.02l-4.5-5.79c1.66-2.49.99-5.86-1.5-7.53-2.49-1.66-5.86-.99-7.53,1.5-1.66,2.49-.99,5.86,1.5,7.53,1.42.95,3.21,1.17,4.83.6l4.5,5.79c.57.74,1.64.88,2.38.31,0,0,.01,0,.02-.01m-3.99-10.59c-.32,2.6-2.69,4.45-5.29,4.12-2.6-.32-4.45-2.69-4.12-5.29.32-2.6,2.69-4.45,5.29-4.12,0,0,0,0,0,0,2.6.33,4.44,2.69,4.12,5.29m3.58,10.07c-.46.34-1.11.26-1.47-.18l-4.39-5.64c.63-.32,1.19-.75,1.66-1.29l4.39,5.64c.34.46.26,1.11-.18,1.47"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_1378"
                d="m220,96.3c-2.99,0-5.4,2.43-5.4,5.41,0,2.72,2.03,5.02,4.73,5.36.22.03.44.04.66.04.62,0,1.23-.11,1.81-.31l4.5,5.79c.31.41.79.66,1.31.67.39,0,.77-.13,1.09-.37.74-.57.88-1.64.31-2.38,0,0,0-.01-.01-.02l-4.5-5.79c1.66-2.48,1-5.83-1.48-7.48-.7-.47-1.51-.77-2.35-.87-.22-.03-.45-.04-.67-.04m0,10.15c-2.62,0-4.75-2.12-4.75-4.74s2.12-4.75,4.74-4.75c2.62,0,4.75,2.12,4.75,4.74,0,.2-.01.4-.04.59-.31,2.37-2.31,4.14-4.7,4.16m7.65,6.12c-.32,0-.63-.14-.84-.39l-4.39-5.64c.63-.32,1.19-.75,1.65-1.29l4.39,5.64c.34.46.26,1.11-.18,1.47-.18.14-.41.21-.63.21"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1379"
                d="m230.22,97.58l-.21,1.47h1.03v.56h-1.12l-.29,2.09h-.67l.3-2.09h-1.52l-.29,2.09h-.67l.29-2.09h-.99v-.56h1.06l.21-1.47h-1.03v-.57h1.11l.29-2.06h.67l-.3,2.06h1.52l.29-2.06h.66l-.3,2.06h.99v.57h-1.06Zm-2.18,0l-.21,1.47h1.52l.21-1.47h-1.52Z"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_1395"
                d="m146.69,93.16l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.19c0,.07,0,.13.01.19,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.76-.02s.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.04-.07.07"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1396"
                d="m172.37,102.73c0,1.08-.88,1.95-1.96,1.96h-2.81c-1.08,0-1.96-.88-1.96-1.96s.88-1.96,1.96-1.96h2.81c1.08,0,1.95.88,1.96,1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1397"
                d="m181.39,102.7v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1398"
                d="m190.87,102.7v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1399"
                d="m200.77,102.7v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1400"
                d="m263.17,102.7v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1401"
                d="m253.1,102.7v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1419"
                d="m298.98,102.73c0-1.08.88-1.95,1.96-1.96h2.81c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h-2.81c-1.08,0-1.95-.88-1.96-1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1420"
                d="m290.26,102.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1421"
                d="m279.98,102.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1422"
                d="m269.43,102.76v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1441"
                d="m225.12,101.71c0,2.91-2.36,5.26-5.26,5.26-2.91,0-5.26-2.36-5.26-5.26,0-2.9,2.36-5.26,5.26-5.26,2.91,0,5.26,2.36,5.26,5.26Z"
                fill="none"
                stroke="#555"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_1442"
                d="m221.98,107.03l4.46,5.7s3.15.94,2.56-2.25l-4.34-5.58"
                fill="none"
                stroke="#555"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <text
                transform="translate(203.51 121.88)"
                fill="#555"
                font-family="SourceSansPro-SemiBold, 'Source Sans Pro'"
                font-size="8"
                font-weight="600"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Finds Project
                </tspan>
                <tspan
                    x="-10.54"
                    y="9.6">
                    Via Project Number
                </tspan>
            </text>
            <path
                id="Path_2252"
                d="m355.96,22.58v7.7h7.19l-.51-7.18s-6.68-.52-6.68-.52Z"
                fill="#cfd5ea"
                stroke-width="0" />
            <path
                id="Path_2257"
                d="m371.82,17.8c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2258"
                d="m363.14,30.28h-7.19c-.28,0-.51-.23-.51-.51h0v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_1485"
                d="m365.81,1.32c9.41,0,17.03,7.63,17.03,17.03s-7.63,17.03-17.03,17.03-17.03-7.63-17.03-17.03h0c0-9.41,7.63-17.03,17.03-17.03"
                fill="#fff"
                stroke="#405184" />
            <rect
                id="Rectangle_308"
                x="368.28"
                y="8.73"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <rect
                id="Rectangle_309"
                x="355.96"
                y="20.86"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1487"
                d="m375.46,16.43h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.17v-6.16h-6.17v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1488"
                d="m359.76,20.26c-.28,0-.52.88-.52.6v-8.53c0-.28.23-.51.51-.51h8.49c.28,0,.51.23.51.51s-.23.51-.51.51h-7.98v8.02c0,.28-.21-.6-.49-.6"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1489"
                d="m372.01,16.08c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1490"
                d="m363.35,28.35h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.67-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <rect
                id="Rectangle_310-2"
                x="347.95"
                y=".5"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
            <g id="Group_715">
                <path
                    id="Path_2499"
                    d="m82.22.5c9.43,0,17.08,7.65,17.08,17.08s-7.65,17.08-17.08,17.08-17.08-7.65-17.08-17.08h0c0-9.43,7.64-17.08,17.08-17.08h0"
                    fill="#fff"
                    stroke="#405184"
                    stroke-miterlimit="10" />
                <path
                    id="Path_2512"
                    d="m79.74,23.59l-2.94,3.36c-.23.29-.18.71.1.94.27.22.66.19.9-.06l2.94-3.36c.23-.28.19-.7-.09-.94-.27-.22-.67-.2-.91.06"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2509"
                    d="m72.29,22.65c.17,0,.34-.07.47-.19l3.22-3.11c.27-.25.28-.67.03-.94s-.67-.28-.94-.03c0,0-.01.01-.02.02l-3.22,3.11c-.27.25-.29.66-.04.93.13.14.31.22.51.21"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2510"
                    d="m79.23,20.18c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2505"
                    d="m92.89,8.17v-.11s-.01-.07-.02-.1c-.01-.04-.03-.07-.05-.11,0-.02-.01-.04-.02-.06l-.03-.03s-.05-.06-.08-.08c-.03-.03-.05-.05-.08-.07l-.03-.03s-.04-.01-.06-.02c-.03-.02-.07-.03-.11-.04-.03-.01-.07-.02-.11-.02h-.11s-.07,0-.11.01c-.02,0-.05,0-.07.01l-20.07,6.73c-.35.1-.55.47-.45.82.06.21.22.37.42.44l9.48,3.63,3.78,9.43c.1.25.35.42.62.42h.02c.28,0,.53-.19.61-.46l6.41-20.17s0-.05.01-.07c0-.04.01-.07.01-.11m-3.09,1.49l-8.04,8.17-7.61-2.91s15.65-5.26,15.65-5.26Zm-4.07,16.66l-3.02-7.55,8.04-8.17s-5.02,15.72-5.02,15.72Z"
                    fill="#405184"
                    stroke-width="0" />
            </g>
        </g>
    </svg>
</template>
